// extracted by mini-css-extract-plugin
export default {"logo":"uba","cancel":"vba","stickyheader":"wba","buttonswrap":"xba","item":"yba","starterKit":"zba","boldHeader":"Aba","reviewheader":"Bba","text":"Cba","username":"Eba"};
    if(module.hot) {
      // 1721922369092
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  